<template>
  <div>
    <v-tooltip v-if="isExecutionPage" top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        outlined
        v-bind="attrs"
        v-on="on"
        @click.stop="deleteExecution()"
      >
        mdi-delete-forever
      </v-icon>
    </template>
    <span>Delete</span>
  </v-tooltip>
  <v-btn v-else
    class="dialog-button"
    color="error"
    @click.stop="deleteExecution()"
  >
    <v-icon left>mdi-delete-forever</v-icon>
    Delete Execution
  </v-btn>
  </div>
</template>

<script>
import {
  showConfirmDialog,
  showSuccessDialog,
  showErrorDialog
} from '@/mixins/utils';

export default {
  name: 'DeleteExecutionButton',
  props: {
    executionId: {
      type: Number,
      required: true
    }
  },
  computed: {
    isExecutionPage() {
      return this.$route.name === 'ExecutionList';
    }
  },
  methods: {
    deleteExecution() {
      const self = this;
      showConfirmDialog(
        'Execution will be deleted',
        'This operation cannot be undone. Are you sure you want to delete it?',
        function() {
          self.api.deleteExecution(
            self.executionId,
            function(data) {
              showSuccessDialog('', 'Execution was deleted.');
              if (self.$route.name !== 'ExecutionList') {
                self.$router.push({ name: 'ExecutionList' });
              } else {
                self.$emit('refresh');
              }
            },
            function(e) {
              console.log(e);
              showErrorDialog(
                'An unexpected error occurred',
                'Try again or let an administrator know if the problem persists.'
              );
            }
          );
        }
      );
    }
  }
};
</script>

<style scoped>
.dialog-button {
  margin-bottom: 5px;
  box-shadow:none;
}
</style>
